import styled from "styled-components";

export interface Props {
  fontSize?: number;
  fontWeigth?: string;
  color?: string;
  margin?: string;
}

export const Title = styled.div`
  font-weight: ${(props: Props) => `${props.fontWeigth || 700}`};
  color:${(props: Props) => `${props.color || '#095AA5'}`}; ;
  font-size: ${(props: Props) => `${props.fontSize || 16}px`};
  margin: ${(props: Props) => `${props.margin || '0px'}`};
`;
